import { Directive, inject } from '@angular/core';
import { FormFieldComponent } from './form-field.component';

/** Puts the field state on the element styled with the `theme/form-field` box mixin. */
@Directive({
  selector: '[cFieldBox]',
  host: {
    '[class.field-box--invalid]': 'field.hasErrors()',
    '[class.field-box--disabled]': 'field.control()?.disabled',
    '[class.field-box--focused]': 'field.focused()',
  },
})
export class FieldBoxDirective {
  protected readonly field = inject(FormFieldComponent);
}
